<div [formGroup]="form" class="container" [kalLoading]="loading">

    <kal-accordion>

        <kal-expansion-panel class="gup-U-margin-bottom--small" expanded>

            <kal-expansion-panel-header>
                <span>Paramètres d'envoi</span>
            </kal-expansion-panel-header>

            <kal-expansion-panel-content>

                <!-- MODELE -->
                @if (publipostageCode) {

                    <div class="modele gup-C-flexGroup -row -justifyBetween -alignEnd">

                        <div class="gup-C-flexGroup__item -demi">

                            <kal-form-field class="gup-C-formFieldSize--select">

                                <kal-select formControlName="model"
                                            displaySearchbar
                                            label="Modèle"
                                            placeholder="Sélectionner un modèle"
                                            disableFirstOptionSelection>
                                    <kal-option [value]="null">Aucun</kal-option>

                                    @for(model of modelEmailList; track model.IdModelEmail) {
                                        <kal-option [value]="model.IdModelEmail">
                                            {{ model.LibelleModelEmail }}
                                        </kal-option>
                                    }

                                </kal-select>

                            </kal-form-field>

                        </div>

                    </div>

                }
                <!-- DESTINATAIRE -->
                <div class="destinataire gup-C-flexGroup -row -justifyBetween -alignEnd">

                    <div class="gup-C-flexGroup__item -demi">

                        <kal-form-field class="gup-C-formFieldSize--select">
                            <kal-select
                                formControlName="to"
                                label="Adresse du destinataire">
                                <kal-option value="personal">Adresse personnelle</kal-option>
                                <kal-option value="professional">Adresse professionnelle</kal-option>
                                <kal-option value="both">Les deux adresses</kal-option>
                                <kal-option value="privileged">Adresse privilégiée</kal-option>
                            </kal-select>
                        </kal-form-field>

                    </div>

                    @let isPrivilegedMail = form.get('to').value === 'privileged';

                    @if(isPrivilegedMail) {
                        <div class="gup-C-flexGroup__item -demi">

                            <kal-form-field class="without-label">
                                <kal-radio-group formControlName="privilegedAddress">
                                    <span>Si non renseignée, choisir :</span>
                                    <kal-radio value="personal">Adresse personnelle</kal-radio>
                                    <kal-radio value="professional">Adresse professionnelle</kal-radio>
                                </kal-radio-group>
                            </kal-form-field>

                        </div>
                    }
                </div>

                <!-- EXPEDITEUR -->
                <div class="expediteur gup-C-flexGroup -row -justifyBetween -alignStart">

                    <div class="gup-C-flexGroup__item -demi">

                        <!-- Expediteur -->
                        <kal-form-field class="gup-C-formFieldSize--select">

                            <kal-select
                                formControlName="from"
                                label="Expéditeur">
                                <kal-option value="ce">Adresse du CSE</kal-option>
                                <kal-option value="commission">Commission</kal-option>
                                <kal-option value="user">Utilisateur</kal-option>
                                <kal-option value="freeEntry">Saisie libre</kal-option>
                            </kal-select>

                        </kal-form-field>

                    </div>

                    <div class="gup-C-flexGroup__item -demi">

                        @switch (fromValue) {
                            <!-- Expediteur ce -->
                            @case ('ce') {
                                <p [class.gup-U-color--red]="!form.get('fromMail').value">
                                    {{ form.get('fromMail').value || 'Aucune adresse e-Mail renseignée' }}
                                </p>
                            }

                            <!-- Expediteur choix commission -->
                            @case('commission') {
                                <kal-form-field class="gup-C-formFieldSize--select">
                                    <kal-select formControlName="fromMail"
                                                label="Commission">

                                        @for (commission of commissionMailList; track commission.AdresseMail) {
                                            <kal-option [value]="commission.AdresseMail">
                                                {{commission.LibelleCommission}}
                                            </kal-option>
                                        }

                                    </kal-select>
                                </kal-form-field>
                            }

                            <!-- Expediteur choix user -->
                            @case('user') {
                                <kal-form-field class="gup-C-formFieldSize--select">
                                    <kal-select
                                        formControlName="fromMail"
                                        label="Adresse de l'utilisateur">
                                        @for (userMail of userMailsAddressesList; track $index) {
                                            <kal-option [value]="userMail">
                                                {{userMail}}
                                            </kal-option>
                                        }
                                    </kal-select>
                                </kal-form-field>
                            }

                            <!-- Expediteur Saisie Libre -->
                            @case('freeEntry') {
                                <kal-form-field>
                                    <kal-input
                                        formControlName="fromMail"
                                        label="E-Mail"/>
                                </kal-form-field>
                            }
                        }

                    </div>

                </div>

            </kal-expansion-panel-content>

        </kal-expansion-panel>

    </kal-accordion>

    <!-- Objet -->
    <kal-form-field>
        <kal-input
            formControlName="subject"
            label="Objet"></kal-input>
    </kal-form-field>

    <div class="editorPublipostage">

        <div>

            <!-- Contenu -->
            <kal-form-field>
                <!-- cas publipostage -->
                <ng-template kalFormFieldLabel>

                    <div class="formlabel">

                        <div>Contenu<span class="gup-U-color--orange">*</span></div>

                        @if(publipostageCode && !shouldDisplayTagsList) {
                            <kal-button (click)="toggleDisplayedTagsList()"
                                        kalTheme="tertiary">
                                Publipostage
                            </kal-button>
                        }

                    </div>

                </ng-template>

                <editor (onChange)="updateFormValueAndValidity()"
                        (onKeyUp)="updateFormValueAndValidity()"
                        (onSelectionChange)="updateFormValueAndValidity()"
                        [init]="editorConfig"
                        formControlName="content">
                </editor>

            </kal-form-field>

                @if(hasFooter) {
                    <kal-form-field>

                        <ng-template kalFormFieldLabel>
                            Pied de page
                        </ng-template>

                        <editor (onChange)="updateFormValueAndValidity()"
                                (onKeyUp)="updateFormValueAndValidity()"
                                (onSelectionChange)="updateFormValueAndValidity()"
                                [init]="editorConfig"
                                formControlName="footer">
                        </editor>

                    </kal-form-field>
                }

        </div>

        <!-- cas publipostage -->
        @if(shouldDisplayTagsList) {
            <div>

                <div class="tagsLabel">
                    <span>Tags</span>
                    <kal-icon (click)="toggleDisplayedTagsList()">
                        close
                    </kal-icon>
                </div>

                <app-shared-mail-publipostage-tags></app-shared-mail-publipostage-tags>

            </div>
        }

    </div>

    @if(publipostageCode) {

        <!-- Liste des documents -->
        <p class="big">Liste des documents</p>

        @if(reportsDocuments.controls.length > 0) {
            <div>
                @for(control of reportsDocuments.controls; track i; let i = $index) {
                    <div formArrayName="reportsDocumentsList">

                        <div [formGroupName]="i">

                            <kal-checkbox [label]="control.value.label"
                                          formControlName="selected">
                            </kal-checkbox>

                        </div>

                    </div>
                }
            </div>
        }

        @if(generatedDocuments.controls.length > 0) {
            <div formArrayName="generatedDocumentsList">
                @for(control of generatedDocuments.controls; track i; let i = $index) {
                    <div [formGroupName]="i">

                        <kal-checkbox [label]="control.value.label"
                                      formControlName="selected">
                        </kal-checkbox>

                    </div>
                }
            </div>
        }

        @for(voucher of vouchersList.controls; track i; let i = $index) {
            <div class="vouchersList__item"
                 formArrayName="vouchersList">

                <div class="gup-C-flexGroup -row">

                    <div class="gup-C-flexGroup__item">
                        <a [href]="voucher.value.Url"
                           target="_blank">
                            <kal-icon>attach_file</kal-icon>
                            {{ voucher.value.LibelleLien || voucher.value.Filename }}
                        </a>
                    </div>

                </div>

                <div class="gup-C-flexGroup -row">
                    <div class="gup-C-flexGroup__item">
                        <a (click)="deleteVoucher(i)" class="gup-O-link -secondary">
                            Supprimer le document
                        </a>
                    </div>
                </div>

            </div>
        }

        <!-- Ajout document -->
        <div class="gup-C-flexGroup -row">
            <div class="gup-C-flexGroup__item">

                <div class="editArticle editArticle__documents">

                    <app-shared-icon-button [kalMenuTriggerFor]="docMenu">
                        Ajouter un document
                    </app-shared-icon-button>

                    <app-simple-file-upload #fileUpload
                                            [extensions]="allowedExtensions"
                                            (fileReaded)="addLocalVoucher($event)">
                    </app-simple-file-upload>

                    <kal-menu #docMenu>
                        <kal-option (selectionChange)="fileUpload.fileUpload.nativeElement.click()">
                            Depuis l'ordinateur
                        </kal-option>

                        <kal-option (selectionChange)="openDocumentsBankDialog()">
                            Depuis la bibliothèque
                        </kal-option>
                    </kal-menu>
                </div>

            </div>
        </div>

    }

</div>
